import React from 'react';
import { tagStyle } from './FooterTag';
import TagsChecklist from "./TagsChecklist";
import Loading from "../vulcan-core/Loading";
import { useCoreTags } from './useCoreTags';
import { defineStyles } from '@/components/hooks/defineStyles';
import { useStyles } from '@/components/hooks/useStyles';

const styles = defineStyles("CoreTagsChecklist", (theme: ThemeType) => ({
  root: {
    marginBottom: 8,
    display: "flex",
    flexWrap: "wrap"
  },
  checkbox: {
    padding: "0 8px 2px 0",
    '& svg': {
      height:14,
      width: 14
    }
  },
  tag: {
    ...tagStyle(theme),
    backgroundColor: "unset",
    color: theme.palette.grey[500],
    border: theme.palette.border.extraFaint,
    '&:hover': {
      border: theme.palette.border.grey300,
      color: theme.palette.grey[800]
    }
  }
})); 

const CoreTagsChecklist = ({onTagSelected, existingTagIds=[]}: {
  onTagSelected?: (tag: {tagId: string, tagName: string}, existingTagIds: Array<string>) => void,
  existingTagIds?: Array<string|undefined>
}) => {
  const classes = useStyles(styles);
  const { data, loading } = useCoreTags();

  const results = data?.tags?.results;
  if (loading) return <Loading/>
  if (!results) return null
  
  return <TagsChecklist tags={results} onTagSelected={onTagSelected} selectedTagIds={existingTagIds}/>
}


export default CoreTagsChecklist;


